const Ink = ({ src, ratio, className, label }) => (
  <span role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}
    className={`inline-block bg-current shrink-0 ${className}`}
    style={{ aspectRatio: ratio, WebkitMaskImage: `url(${src})`, maskImage: `url(${src})`, WebkitMaskSize: "contain", maskSize: "contain",
      WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat", WebkitMaskPosition: "center", maskPosition: "center" }} />
);

export const LogoMark = ({ className = "h-9" }) => <Ink src="/brand/initiales.png" ratio="526 / 328" className={className} />;

export const LogoFull = ({ className = "h-12" }) => <Ink src="/brand/logo.png" ratio="1296 / 469" className={className} label="Christine P. artiste peintre" />;

export const Logo = ({ light = false, onClick, testid = "nav-logo-link", size = "nav" }) => (
  <a href="#top" onClick={onClick} data-testid={testid}
    className={`group flex items-center ${light ? "text-[#F6F1E9]" : "text-[#15202B]"}`}>
    <LogoFull className={`${size === "lg" ? "h-16 sm:h-20" : "h-11 sm:h-12"} transition-transform duration-700 group-hover:-rotate-2`} />
  </a>
);
